/**
 * Formato de número de OC — Numeración Unificada (CHS 2026-04-21).
 *
 * Ya no existe numeración separada W-XXXXX. Todas las OCs usan una única
 * secuencia que continúa desde el último n_orden de Access. Las OCs Web
 * migradas conservan `numero_oc_legacy` (ej. "W-00028") para trazabilidad.
 */
import React from 'react';

/**
 * String corto para mostrar en grids/celdas (una línea).
 * Ej: "18562" o "18562 (ex W-00001)" si viene de migración.
 */
export function ocDisplayInline(oc) {
  if (!oc) return '';
  const n = oc.numero_oc || '';
  const legacy = oc.numero_oc_legacy;
  if (legacy) return `${n} (ex ${legacy})`;
  return String(n);
}

/**
 * Número primario (el que se usa en textos tipo "OC 7846").
 */
export function ocPrimary(oc) {
  if (!oc) return '';
  return String(oc.numero_oc || '');
}

/**
 * Componente visual. size: 'sm'|'md'|'lg'.
 */
export function OCNumber({ oc, size = 'md', className = '' }) {
  if (!oc) return null;
  const n = oc.numero_oc || '';
  const legacy = oc.numero_oc_legacy;

  const sizes = {
    sm: { primary: 'text-xs font-semibold', secondary: 'text-[10px]' },
    md: { primary: 'text-sm font-semibold', secondary: 'text-[11px]' },
    lg: { primary: 'text-base font-bold', secondary: 'text-xs' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`leading-tight ${className}`} data-testid="oc-number">
      <div className={s.primary}>OC {n}</div>
      {legacy && (
        <div className={`${s.secondary} text-muted-foreground`} title={`Antes: ${legacy}`}>
          ex {legacy}
        </div>
      )}
    </div>
  );
}
